export function formatNumber(value) {
  if (value === null || value === undefined) {
    return '';
  }

  return value.toLocaleString(
    'en-US',
    {
      maximumFractionDigits: 1
    }
  );
}